<template>
  <div class="newsList">
    <!--新闻列表-->
    <breadcrumb class="breadcrumb" />
    <el-row class="main-container">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <el-form :inline="true" class="demo-form-inline" size="small">
            <el-form-item label="标题：">
              <el-input
                v-model="title"
                placeholder="输入标题"
                @keyup.enter.native="onSubmit"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="类型：">
              <el-select
                v-model="type_search"
                placeholder="请选择"
                @change="choose"
              >
                <el-option
                  v-for="(item, index) in options3"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="日期：">
              <el-date-picker
                :clearable="false"
                v-model="dateArr"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item style="margin-left: 15px">
              <el-button type="primary" @click="onSubmit" icon="el-icon-search"
                >查询</el-button
              >
            </el-form-item>
            <div class="treeOption">
              <el-button
                type="success"
                size="small"
                icon="el-icon-plus"
                @click="addNews"
                >新增</el-button
              >
              <el-button
                type="danger"
                size="small"
                icon="el-icon-delete"
                @click="deleteNews"
                >删除</el-button
              >
            </div>
          </el-form>
        </div>
        <div class="tableCenter">
          <el-table
            :data="newsList"
            style="width: 100%"
            border
            @selection-change="handleSelectionChange"
            :row-key="getRowKeys"
            :expand-row-keys="expands"
            @expand-change="handleExpand"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column type="index"> </el-table-column>
            <el-table-column type="expand">
              <template slot-scope="props">
                <el-form label-position="left" inline class="demo-table-expand">
                  <el-form-item label="标题">
                    <span>{{ props.row.title }}</span>
                  </el-form-item>
                  <el-form-item label="发布时间">
                    <span>{{ props.row.publishtime }}</span>
                  </el-form-item>
                  <el-form-item label="类型">
                    <span>{{ props.row.typename }}</span>
                  </el-form-item>
                  <el-form-item label="简介">
                    <span>{{ props.row.summary }}</span>
                  </el-form-item>
                  <el-form-item label="缩略图" class="el-form-img">
                    <span><img :src="props.row.thumbnail" /></span>
                  </el-form-item>
                  <el-form-item label="内容" class="el-form-content">
                    <div class="expandQuillEditor">
                      <quill-editor
                        ref="myQuillEditorExpand"
                        v-model="contentExpand"
                        id="quillEditor_Expand"
                        :options="editorOption"
                      ></quill-editor>
                    </div>
                  </el-form-item>
                </el-form>
              </template>
            </el-table-column>
            <el-table-column prop="title" label="标题"> </el-table-column>
            <el-table-column prop="publishtime" label="发布时间">
            </el-table-column>
            <el-table-column prop="typename" label="类型"> </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="modifyNews(scope.row)"
                  >修改</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            style="margin-top: 15px; float: right"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNo"
            :page-sizes="[20, 50, 100, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          >
          </el-pagination>
        </div>
      </el-card>
    </el-row>
    <!--新增dialog-->
    <el-dialog
      :title="newsTitleName"
      :visible.sync="dialogAddChange"
      width="800px"
      :close-on-click-modal="false"
      @open="initDialog"
      class="top"
    >
      <div>
        <el-form ref="form" :model="formResult" label-width="100px">
          <el-form-item label="标题：">
            <el-input v-model="formResult.title"></el-input>
          </el-form-item>
          <el-form-item label="类型：">
            <el-select
              v-model="formResult.type"
              placeholder="请选择"
              @change="choose"
            >
              <el-option
                v-for="(item2, index2) in options2"
                :key="index2"
                :label="item2.label"
                :value="item2.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发布方式：">
            <el-radio-group
              v-model="formResult.publishtype"
              @change="showSelectTime"
            >
              <el-radio label="1">定时发布</el-radio>
              <el-radio label="2">立即发布</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="发布时间：" v-show="showSelectTimeVal">
            <div class="block">
              <el-date-picker
                v-model="formResult.publishtime"
                type="datetime"
                placeholder="选择发布时间"
              >
              </el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="缩略图：">
            <el-input v-model="formResult.thumbnail" type="hidden"></el-input>
            <el-upload
              ref="upload"
              class="upload-demo"
              action="/api/news/uploadPic"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :on-success="handleSuccess"
              :file-list="fileList"
              :limit="1"
              list-type="picture"
              style="margin-top: -5%"
            >
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">
                只能上传jpg/png文件，且不超过500kb
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item label="简介：">
            <el-input type="textarea" v-model="formResult.summary"></el-input>
          </el-form-item>
          <el-form-item label="内容">
            <!-- <el-input v-model="formResult.content" type="textarea"></el-input> -->
            <!-- <div ref="editor"></div> -->
            <el-upload
              class="avatar-uploader"
              action="/api/news/uploadPic"
              :headers="header"
              :show-file-list="false"
              :before-upload="beforeUpload"
            >
            </el-upload>
            <quill-editor
              ref="myQuillEditor"
              v-model="content"
              id="quillEditor"
              :options="editorOption"
              @blur="onEditorBlur($event)"
              @focus="onEditorFocus($event)"
              @change="onEditorChange($event)"
            ></quill-editor>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <div style="display: flex; justify-content: center">
          <el-button @click="dialogAddChange = false" style="margin-right: 20px"
            >取 消</el-button
          >
          <el-button type="primary" @click="submitNews">确 定</el-button>
        </div>
      </span>
    </el-dialog>
    <el-dialog top="5vh" :visible.sync="isShowCropper" id="vueCropper">
      <VueCropper
        style="height: 600px; margin: 20px 0"
        ref="cropper"
        :img="option.img"
        :outputSize="option.outputSize"
        :outputType="option.outputType"
        :info="option.info"
        :canScale="option.canScale"
        :autoCrop="option.autoCrop"
        :autoCropWidth="option.autoCropWidth"
        :autoCropHeight="option.autoCropHeight"
        :fixed="option.fixed"
        :fixedNumber="option.fixedNumber"
      >
      </VueCropper>
      <br />
      <div style="display: flex; justify-content: center">
        <el-button @click="isShowCropper = false">取消裁剪</el-button>
        <el-button type="primary" @click="onCubeImg()">确定剪裁</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import { VueCropper } from 'vue-cropper'
//import Editor from 'wangeditor'
import { setTimeout } from 'timers'
const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'], // toggled buttons
  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
  [{ direction: 'rtl' }], // text direction
  [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [{ font: [] }],
  [{ align: [] }],
  ['link', 'image'],
  ['clean'],
]
export default {
  components: {
    VueCropper,
  },
  data() {
    return {
      contentExpand: null, //expand展开富文本
      header: {
        // token: sessionStorage.token
      }, // 有的图片服务器要求请求头需要有token
      quillUpdateImg: false, // 根据图片上传状态来确定是否显示loading动画，刚开始是false,不显
      content: `<p>请输入文本内容...</p>`, //富文本渲染内容body 重要！
      editorOption: {
        placeholder: '',
        theme: 'snow', // or 'bubble'
        modules: {
          imageResize: {
            displayStyles: {
              backgroundColor: 'black',
              border: 'none',
              color: 'white',
            },
            modules: ['Resize', 'DisplaySize', 'Toolbar'],
          },
          toolbar: {
            container: toolbarOptions,
            handlers: {
              image: function (value) {
                if (value) {
                  // 触发input框选择图片文件
                  document.querySelector('.avatar-uploader input').click()
                } else {
                  this.quill.format('image', false)
                }
              },
            },
          },
        },
      },
      // 切图器数据
      option: {
        img: '', // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 1, // 裁剪生成图片的质量
        outputType: 'png', // 裁剪生成图片的格式
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 150, // 默认生成截图框宽度
        autoCropHeight: 150, // 默认生成截图框高度
        fixed: false, // 是否开启截图框宽高固定比例
        fixedNumber: [4, 4], // 截图框的宽高比例
      },
      isShowCropper: false,
      newsTitleName: '',
      dialogAddChange: false,
      title: '',
      dateArr: [],
      newsList: [],
      fileList: [],
      isadd: true,
      formResult: {
        ID: '',
        title: '',
        type: '',
        thumbnail: '',
        content: '',
        picname: '',
        publishtime: '',
        publishtype: '1',
        summary: '',
      },
      multipleSelection: [],
      pageSize: 20,
      pageNo: 1,
      totalCount: 0,
      options3: [
        {
          value: '1',
          label: '公司新闻',
        },
        {
          value: '2',
          label: '行业新闻',
        },
        {
          value: '3',
          label: '媒体报道',
        },
      ],
      options2: [
        {
          value: '1',
          label: '公司新闻',
        },
        {
          value: '2',
          label: '行业新闻',
        },
        {
          value: '2',
          label: '媒体报道',
        },
      ],
      type_search: '',
      type: '',
      editorContent: '',
      editor: null,
      view_editor: null,
      expands: [],
      showSelectTimeVal: true,
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    choose(value) {
      if (value == '3') {
        this.type_search = '2'
      } else {
        this.type_search = value
      }
    },
    // 富文本图片上传失败
    uploadError() {
      // loading动画消失
      this.quillUpdateImg = false
      this.$message.error('图片插入失败')
    },
    // 上传切图前调用
    beforeUpload(file) {
      this.$confirm('是否，选择裁剪图片?', '提示', {
        confirmButtonText: '确定裁剪',
        cancelButtonText: '直接上传',
        type: 'warning',
      })
        .then(() => {
          this.option.img = URL.createObjectURL(file)
          this.option.autoCropWidth = this.width
          this.option.autoCropHeight = this.height
          this.isShowCropper = true
          return false
        })
        .catch(() => {
          var fd2 = new FormData()
          fd2.append('file', file)
          this.axios.post('/news/uploadPic', fd2).then((res) => {
            // 获取富文本组件实例
            let quill = this.$refs.myQuillEditor.quill
            this.quillUpdateImg = false
            if (res.data.resultCode === '00') {
              this.$message({
                message: '图片插入成功',
                type: 'success',
              })
              let length = quill.getSelection().index
              quill.insertEmbed(length, 'image', res.data.url)
              quill.setSelection(length + 1)
            } else {
              this.$message({
                message: '图片插入失败',
                type: 'error',
              })
            }
          })
        })
    },
    // 确定裁剪图片
    onCubeImg() {
      // 获取cropper的截图的base64 数据
      this.$refs.cropper.getCropData((data) => {
        this.isShowCropper = false
        // 先将显示图片地址清空，防止重复显示
        this.option.img = ''
        // 将剪裁后base64的图片转化为file格式
        var file = this.convertBase64UrlToBlob(data)
        file.name = 'img' + new Date().getTime()
        // 将剪裁后的图片执行上传
        var fd = new FormData()
        fd.append('file', file)
        this.axios.post('/news/uploadPic', fd).then((res) => {
          // 获取富文本组件实例
          let quill = this.$refs.myQuillEditor.quill
          // loading动画消失
          this.quillUpdateImg = false
          // 如果上传成功
          if (res.data.resultCode === '00') {
            this.$message({
              message: '裁剪图片插入成功',
              type: 'success',
            })
            // 获取光标所在位置
            let length = quill.getSelection().index
            // 插入图片  res.url为服务器返回的图片地址
            quill.insertEmbed(length, 'image', res.data.url)
            // 调整光标到最后
            quill.setSelection(length + 1)
          } else {
            this.$message({
              message: '图片插入失败',
              type: 'error',
            })
          }
        })
      })
    },
    // 将base64的图片转换为file文件
    convertBase64UrlToBlob(urlData) {
      let bytes = window.atob(urlData.split(',')[1]) //去掉url的头，并转换为byte
      //处理异常,将ascii码小于0的转换为大于0
      let ab = new ArrayBuffer(bytes.length)
      let ia = new Uint8Array(ab)
      for (var i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i)
      }
      return new Blob([ab], { type: 'image/png' })
    },
    onEditorChange({ editor, html, text }) {
      //内容改变事件
      this.content = html
    },
    onEditorBlur() {}, // 失去焦点事件
    onEditorFocus() {}, // 获得焦点事件
    //初始化方法
    init() {
      let vm = this
      let params = {
        title: vm.title,
        dateArr: vm.dateArr,
        typevalue: vm.type_search,
        pageNo: vm.pageNo,
        pageSize: vm.pageSize,
        comefrom: '1', //后台管理查看所有记录
      }
      vm.axios
        .get('/news/queryNewsList', { params: params })
        .then((res) => {
          vm.newsList = []
          res.data.newsList.list.forEach((val) => {
            val.publishtime = val.publishtime
              ? moment(val.publishtime).utc(0).format('YYYY-MM-DD HH:mm:ss')
              : ''
            if (val.type == '1') {
              val.typename = '公司新闻'
            } else if (val.type == '2') {
              val.typename = '行业新闻'
            } else if (val.type == '3') {
              val.typename = '媒体报道'
            }
            vm.newsList.push(val)
          })
          vm.totalCount = res.data.newsList.count[0].count
        })
        .catch((error) => {})
    },
    //查询
    onSubmit() {
      this.init()
    },
    //pageSize改变事件
    handleSizeChange(val) {
      let vm = this
      vm.pageSize = val
      vm.pageNo = 1
      this.init()
    },
    //pageNo改变事件
    handleCurrentChange(val) {
      let vm = this
      vm.pageNo = val
      this.init()
    },
    //新增
    addNews() {
      let vm = this
      vm.content = `<p>请输入文本内容...</p>`
      vm.isadd = true
      vm.formResult.title = ''
      vm.formResult.type = ''
      vm.formResult.thumbnail = ''
      vm.formResult.content = ''
      vm.formResult.picname = ''
      vm.formResult.publishtime = ''
      vm.formResult.publishtype = '1'
      vm.formResult.summary = ''
      vm.editorContent = ''
      if (vm.editor) {
        vm.editor.txt.html('')
      }
      vm.menuTitleName = '新增'
      vm.dialogAddChange = true
      setTimeout(() => {
        this.$refs.upload.clearFiles()
      })
    },
    //修改
    modifyNews(row) {
      let vm = this
      vm.isadd = false
      vm.menuTitleName = '修改'
      vm.formResult.ID = row.ID
      vm.formResult.title = row.title
      vm.formResult.type = row.type
      vm.formResult.thumbnail = row.thumbnail
      vm.formResult.picname = row.picname
      vm.formResult.content = row.content
      vm.content = row.content
      vm.editorContent = row.content
      vm.formResult.publishtime = row.publishtime
      vm.formResult.publishtype = row.publishtype
      vm.formResult.summary = row.summary
      vm.showSelectTime()
      vm.dialogAddChange = true
      setTimeout(() => {
        this.$refs.upload.clearFiles()
        vm.fileList = [{ name: row.picname, url: row.thumbnail }]
        if (vm.editor) {
          vm.editor.txt.html(row.content)
        }
      })
    },
    submitNews() {
      let vm = this
      let params = {}
      params.title = vm.formResult.title
      params.type = vm.formResult.type
      params.thumbnail = vm.formResult.thumbnail
      params.picname = vm.formResult.picname
      //params.content = vm.editorContent;
      params.content = vm.content //更改富文本渲染内
      params.publishtime = vm.formResult.publishtime
      params.publishtype = vm.formResult.publishtype
      params.summary = vm.formResult.summary
      if (vm.isadd) {
        vm.axios
          .post('/news/saveNews', { params: params })
          .then((res) => {
            if (res.data.resultCode === '00') {
              vm.init()
              vm.dialogAddChange = false
              vm.content = `<p>请输入文本内容...</p>` //富文本渲染内容body 重要！
              this.$message({
                showClose: true,
                message: '添加成功',
                type: 'success',
              })
            }
          })
          .catch((error) => {
            this.$message({
              showClose: true,
              message: '添加失败',
              type: 'error',
            })
          })
      } else {
        params.ID = vm.formResult.ID
        vm.axios
          .post('/news/modifyNews', { params: params })
          .then((res) => {
            if (res.data.resultCode === '00') {
              vm.init()
              vm.dialogAddChange = false
              this.$message({
                showClose: true,
                message: '修改成功',
                type: 'success',
              })
            }
          })
          .catch((error) => {
            this.$message({
              showClose: true,
              message: '修改失败',
              type: 'error',
            })
          })
      }
    },
    deleteNews() {
      let vm = this
      if (vm.multipleSelection.length > 0) {
        this.$confirm('确定要删除所选内容吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            vm.axios
              .post('/news/deleteNews', { params: vm.multipleSelection })
              .then((res) => {
                if (res.data.resultCode === '00') {
                  vm.init()
                  this.$message({
                    showClose: true,
                    message: '删除成功',
                    type: 'success',
                  })
                }
              })
              .catch((error) => {
                this.$message({
                  showClose: true,
                  message: '删除失败',
                  type: 'error',
                })
              })
          })
          .catch(() => {})
      } else {
        this.$message({
          showClose: true,
          message: '请选择需要删除的内容',
          type: 'warning',
        })
      }
    },
    handleSuccess(file, fileList) {
      this.formResult.thumbnail = file.url
      this.formResult.picname = file.picname
    },
    handleRemove(file, fileList) {
      this.formResult.thumbnail = ''
      this.formResult.picname = ''
    },
    handlePreview(file) {
      console.log(file)
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    //老富文本 废弃不能裁剪
    initDialog() {
      let vm = this
      // this.$nextTick(()=>{
      //   if(!vm.editor){
      //     vm.editor = new Editor(this.$refs.editor);
      //     vm.editor.customConfig.menus = [
      //       'head',  // 标题
      //       'bold',  // 粗体
      //       'fontSize',  // 字号
      //       'fontName',  // 字体
      //       'italic',  // 斜体
      //       'underline',  // 下划线
      //       'strikeThrough',  // 删除线
      //       'foreColor',  // 文字颜色
      //       'backColor',  // 背景颜色
      //       'link',  // 插入链接
      //       'list',  // 列表
      //       'justify',  // 对齐方式
      //       'quote',  // 引用
      //       'emoticon',  // 表情
      //       'image',  // 插入图片
      //       'table',  // 表格
      //     ];
      //     vm.editor.customConfig.onchange = (html) => {
      //       vm.editorContent = html;
      //     }
      //     vm.editor.customConfig.uploadImgServer = 'news/uploadPic';//图片上传路径
      //     vm.editor.customConfig.uploadFileName = 'file';
      //     // 图片上传并返回结果，自定义插入图片的事件
      //     vm.editor.customConfig.uploadImgHooks = {
      //       before: function (xhr, editor, files) {
      //         console.log(111);
      //       },
      //       customInsert: function (insertImg, result, editor) {
      //         var url =result.url;
      //         insertImg(url);
      //       }
      //     }
      //     vm.editor.create();
      //   }
      // })
    },
    handleExpand: function (row, expandedRows) {
      let vm = this
      vm.view_editor = null
      $('#view_editor').empty()
      if (expandedRows.length) {
        vm.expands = []
        if (row) {
          vm.expands.push(row.ID)
          vm.contentExpand = row.content
        }
      } else {
        vm.expands = []
        vm.contentExpand = null
      }
      // setTimeout(() => {
      //   vm.view_editor = new Editor('#view_editor')
      //   vm.view_editor.customConfig.menus = [
      //     'head', // 标题
      //     'bold', // 粗体
      //     'fontSize', // 字号
      //     'fontName', // 字体
      //     'italic', // 斜体
      //     'underline', // 下划线
      //     'strikeThrough', // 删除线
      //     'foreColor', // 文字颜色
      //     'backColor', // 背景颜色
      //     'link', // 插入链接
      //     'list', // 列表
      //     'justify', // 对齐方式
      //     'quote', // 引用
      //     'emoticon', // 表情
      //     'image', // 插入图片
      //     'table', // 表格
      //   ]
      //   vm.view_editor.create()
      //   vm.view_editor.$textElem.attr('contenteditable', false)
      //   vm.view_editor.txt.html(row.content)
      // })
    },
    getRowKeys: function (row) {
      return row.ID
    },

    showSelectTime: function () {
      let vm = this
      if (vm.formResult.publishtype == 1) {
        vm.showSelectTimeVal = true
      } else {
        vm.showSelectTimeVal = false
      }
    },
  },
}
</script>

<style scoped lang="scss">
#vueCropper {
  z-index: 100000 !important;
}
//ID类名唯一 不能同名
#quillEditor_Expand >>> .ql-editor {
  height: 500px !important;
  overflow-y: auto !important;
}
#quillEditor >>> .ql-editor {
  height: 500px !important;
  overflow-y: auto !important;
}
.newsList {
  .main-container {
    .tableCenter {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
    }
  }
  .top {
    z-index: 10001 !important;
  }
}
</style>
<style>
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf !important;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}

.demo-table-expand .el-form-img {
  margin-right: 0;
  margin-bottom: 0;
  width: 100%;
}

.demo-table-expand .el-form-img img {
  width: 50%;
}

.demo-table-expand .el-form-content {
  margin-right: 0;
  margin-bottom: 0;
  width: 100%;
}
.demo-table-expand .el-form-content .el-form-item__content {
  width: 100%;
}
.el-popper {
  z-index: 10002 !important;
}
.el-message-box__wrapper {
  z-index: 100004 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/management/newsList.vue